import React from "react";
import { AlertCircle, ArrowLeft, RefreshCw, XCircle } from "lucide-react";
import { Button } from "../../ui/button";

export const ReportError = ({ error, onRetry, onBack }) => (
  <div className="min-h-screen flex items-center justify-center bg-slate-950">
    <div className="text-center">
      <AlertCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
      <p className="text-white font-medium mb-2" data-testid="report-error-title">Error loading report</p>
      <p className="text-slate-400 mb-4" data-testid="report-error-message">{error}</p>
      <div className="flex items-center justify-center gap-3">
        <Button onClick={onRetry} className="bg-emerald-500 hover:bg-emerald-600" data-testid="retry-report-btn">
          <RefreshCw className="w-4 h-4 mr-2" /> Retry
        </Button>
        <Button onClick={onBack} variant="outline" className="border-slate-700 text-slate-300">
          <ArrowLeft className="w-4 h-4 mr-2" /> Go Back
        </Button>
      </div>
    </div>
  </div>
);

export const ReportFailed = ({ onBack }) => (
  <div className="min-h-screen flex items-center justify-center bg-slate-950">
    <div className="text-center max-w-md">
      <XCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
      <p className="text-white font-medium mb-2">Report Generation Failed</p>
      <p className="text-slate-400 mb-4">
        We encountered an error while generating your brand strategy. Please try again.
      </p>
      <Button onClick={onBack} variant="outline" className="border-slate-700 text-slate-300">
        <ArrowLeft className="w-4 h-4 mr-2" /> Try Again
      </Button>
    </div>
  </div>
);
